import { useEffect, useState } from "react";

export function useCurrentMonth() {
  // Holt den aktuellen Monat im Format YYYY-MM (z.B. "2025-04")
  const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // z.B. 04 statt 4
    return `${year}-${month}`;
  };

  const [currentMonth, setCurrentMonth] = useState(getCurrentMonth());

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedMonth = getCurrentMonth();
      if (updatedMonth !== currentMonth) {
        setCurrentMonth(updatedMonth);
      }
    }, 60000); // alle 60 Sekunden prüfen

    return () => clearInterval(interval); // Aufräumen
  }, [currentMonth]);

  return currentMonth;
}
